/* Aurora 2027 · animación con función: titulares que suben palabra por palabra, fotos que se
   revelan, persona del héroe con profundidad, botones que se acercan al cursor y una frase
   que avanza con el scroll. Todo se apaga con prefers-reduced-motion. */
(function(){
"use strict";
const $$ = (s, r=document) => [...r.querySelectorAll(s)];
if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
document.documentElement.classList.add("anima");

/* 1 · titulares: envolver cada palabra conservando <i> y spans */
function partir(el){
  if (el.dataset.partido) return; el.dataset.partido = 1;
  let n = 0;
  const recorrer = nodo => {
    [...nodo.childNodes].forEach(c => {
      if (c.nodeType === 3) {
        const frag = document.createDocumentFragment();
        c.textContent.split(/(\s+)/).forEach(t => {
          if (!t) return;
          if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
          const w = document.createElement("span"); w.className = "pal";
          const i = document.createElement("span"); i.textContent = t; i.style.transitionDelay = (n++ * 45) + "ms";
          w.appendChild(i); frag.appendChild(w);
        });
        c.replaceWith(frag);
      } else if (c.nodeType === 1 && !c.classList.contains("ifoto") && c.tagName !== "IMG") recorrer(c);
      else if (c.nodeType === 1) { c.classList.add("pal-obj"); c.style.transitionDelay = (n++ * 45) + "ms"; }
    });
  };
  recorrer(el);
}
const titulos = () => $$(".h2:not(.dest__nom), .intro2 h2, .bento-h .h2, .pbox .h1, .ghero .h1, .phead .h1");
const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("visto"); io.unobserve(e.target); } }), {rootMargin:"0px 0px -10% 0px"});
const armar = () => { titulos().forEach(t => { partir(t); io.observe(t); }); $$(".rv-img:not(.visto)").forEach(f => io.observe(f)); };

/* 2 · fotos grandes que se revelan */
const marcarFotos = () => $$(".dest__foto, .muesca__fig svg, .bcard--b img, .f2__f, .hist img, .gbanner--foto, .guia-dest, .galeria__main, .mapa__fig").forEach(f => f.classList.add("rv-img"));

/* 3 · héroe: profundidad con el mouse y con el scroll */
const hero = document.querySelector(".hv2__box");
if (hero) {
  const per = hero.querySelector(".hv2__persona"), card = hero.querySelector(".pcard");
  let tx = 0, ty = 0, cx = 0, cy = 0, sy = 0;
  hero.addEventListener("pointermove", e => { const r = hero.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width - .5; ty = (e.clientY - r.top) / r.height - .5; });
  hero.addEventListener("pointerleave", () => { tx = ty = 0; });
  addEventListener("scroll", () => { sy = Math.min(scrollY, 700); }, {passive:true});
  const loop = () => {
    cx += (tx - cx) * .06; cy += (ty - cy) * .06;
    if (per) per.style.transform = `translate3d(${cx * -18}px, ${cy * -6}px, 0)`;
    if (card) card.style.setProperty("--px", `${cx * 14}px`), card.style.setProperty("--py", `${cy * 10}px`);
    hero.style.setProperty("--esc", 1 - sy / 700 * .035);
    requestAnimationFrame(loop);
  };
  loop();
}

/* 4 · botones principales que se acercan al cursor */
if (matchMedia("(hover:hover)").matches) {
  document.addEventListener("pointermove", e => {
    const b = e.target.closest(".btn--sol, .btn--tinta, .circulo");
    $$(".iman").forEach(x => { if (x !== b) { x.style.transform = ""; x.classList.remove("iman"); } });
    if (!b || b.closest(".drawer,.modal")) return;
    const r = b.getBoundingClientRect();
    b.classList.add("iman");
    b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .18}px, ${(e.clientY - r.top - r.height / 2) * .28}px)`;
  });
}

/* 5 · frase grande que avanza con el scroll */
$$("[data-cinta]").forEach(c => {
  const fila = c.firstElementChild;
  const mover = () => { const r = c.getBoundingClientRect(); const p = (innerHeight - r.top) / (innerHeight + r.height); fila.style.transform = `translateX(${-p * 30}%)`; };
  addEventListener("scroll", () => requestAnimationFrame(mover), {passive:true}); mover();
});

marcarFotos(); armar();
/* las páginas que pintan después (tienda, guía, ficha) */
new MutationObserver(() => { clearTimeout(window._anT); window._anT = setTimeout(() => { marcarFotos(); armar(); }, 60); }).observe(document.querySelector("main") || document.body, {childList:true, subtree:true});
})();
